// Childish and untainted

document.querySelectorAll(".products-section  div.tabs").forEach(function(el) {
  var active, content
  var links = el.querySelectorAll("a")
  
  links.forEach(function(item, index) {
    if (index == 0) {
      item.closest(".test").classList.add('active_custom')
      active = item
      content = item.closest(".products-section").querySelector(`${item.getAttribute("data-href")}`)
      content.classList.add("active")
    } else {
      var el = item.closest(".products-section").querySelector(`${item.getAttribute("data-href")}`);
      el.style.display = "none";
      el.classList.remove("active");
    }
  })
  
  el.querySelectorAll(".test").forEach(function(item) {
    item.addEventListener("click", function() {
      links.forEach(function(item)  {
        item.closest(".test").classList.remove('active_custom')
      })
      item.classList.add('active_custom')
      content.style.display = "none"
      content.classList.remove("active")
      active = this.querySelector("a")
      content = item.closest(".products-section").querySelector(` ${active.getAttribute("data-href")}`)
      content.style.display = "block"
      content.classList.add("active")
    }, true)
  })
})

document.querySelectorAll("div.tabs.blogs").forEach(function(el) {
  var active, content
  var links = el.querySelectorAll("a")
  links.forEach(function(item, index) {
    if (index == 0) {
      item.closest("div").classList.add('active_custom')
      active = item
      content = document.querySelector(`.bss-custom-blog-wrapper ${item.getAttribute("data-href")}`)
      content.classList.add("active")
    } else {
      var el = document.querySelector(`.bss-custom-blog-wrapper ${item.getAttribute("data-href")}`);
      el.style.height = "0px"
      el.style.overflowY = "hidden"
      el.classList.remove("active")
    }
  })
  
  el.querySelectorAll("a").forEach(function(item) {
    item.addEventListener("click", function() {
      links.forEach(function(item) {
        item.closest("div").classList.remove('active_custom')
      })
      item.closest("div").classList.add('active_custom')
      content.style.height = "0px"
      content.style.overflowY = "hidden"
      content.classList.remove("active")
      active = this
      content = document.querySelector(`.bss-custom-blog-wrapper ${active.getAttribute("data-href")}`)
      content.style.height = "auto"
      content.style.overflowY = "auto"
      content.classList.add("active")
    }, true)
  })
})

if(!window.changeTab){
  window.changeTab = function(el) {
    var e = document.querySelector(".toolbar-logo img");
    
    // Keep this on top to prevent old firefox bug
    e.loading = "lazy";
    e.src = "https://cdn.shopify.com/s/files/1/0456/5070/6581/files/Frame_60667_91855965-e217-4576-a0c5-0dae379366bd.png?v=1684136168"
    e.style.width="200px!important"
    document.getElementById(el).closest(".item-wrapper").classList.add("collection-link-selected")
  }
}


if (window.location.pathname.normalize('NFC') == encodeURI("/collections/nam")) {
  changeTab("man-path")
  document.getElementById("man-path").parentElement.style.borderRight = "none"
} else if (window.location.pathname.normalize('NFC') == encodeURI("/collections/nu")) {
  changeTab("women-path")
  document.getElementById("man-path").parentElement.style.borderRight = "none"
  document.getElementById("women-path").parentElement.style.borderRight = "none"
} else if (window.location.pathname.normalize('NFC') == encodeURI("/collections/tre-em")) {
  changeTab("kid-path")
  document.getElementById("women-path").parentElement.style.borderRight = "none"
}

var btnScrollTop = document.querySelector(".custom-back-to-top");

var scrollHandler = () => {
  if(!btnScrollTop){
    return;
  }
  var scrollPosition = window.scrollY 
  if ( scrollPosition > 0) {
    btnScrollTop.style.display = 'block'
  } else {
    btnScrollTop.style.display = 'none'
  }
}

if(window.innerWidth < 768 && document.querySelector(".boost-pfs-filter-tree-mobile-button")) {
  document.querySelector(".boost-pfs-filter-tree-mobile-button").addEventListener("click", function(){
    document.querySelector(".bss-sticky-navbar-wrapper").style.zIndex = "0"
    document.querySelector(".boost-pfs-filter-close").addEventListener("click", function() {
      document.querySelector(".bss-sticky-navbar-wrapper").style.zIndex = "5"
    })
    document.querySelector(".boost-pfs-filter-show-result").addEventListener("click", function() {
      document.querySelector(".bss-sticky-navbar-wrapper").style.zIndex = "5"
    })
  })
}

function handleBssFooterStyling(params) {
  if (window.matchMedia('(min-width: 750px)').matches) {
    return
  }

  var handleCollapse = function(heading) {
    if (heading.classList.contains('block-collapsed')) {
      heading.classList.remove('block-collapsed')
      heading.setAttribute('aria-expanded', 'true')
    } else {
      heading.classList.add('block-collapsed')
      heading.setAttribute('aria-expanded', 'false')
    }
  }

  document.querySelectorAll('.accordion .bss-custom-footer-title').forEach(function(heading, index) {
    heading.classList.add('block-collapsed')
    // heading.setAttribute('role', 'button')
    heading.setAttribute('aria-expanded', 'false')
    heading.setAttribute('tabindex', '0')

    heading.nextElementSibling.setAttribute('id', `footer-block-index-${index}`)
    heading.setAttribute('aria-controls', `footer-block-index-${index}`)

    heading.addEventListener('click', function(){ handleCollapse(heading) })
    heading.addEventListener('keypress', function () { handleCollapse(heading) })
  })
}



// if (window.innerWidth < 748) {
//   setTimeout(() => {
//     var el = document.querySelector(".tabs.blogs");
//     if (el) {
//       document.querySelector(".bss-custom-blog-wrapper").appendChild(el);
//       el.style.padding = "0px";
//       document.querySelector(".tabs.blogs li");
//     }
//   }, 500)
// }


const oldScrollingEl = document.querySelector(".vertical-scrolling-text");

if(oldScrollingEl){
  var {children: titles} = oldScrollingEl;
  var txtsLen = titles.length;
  var index = 0;
  var textInTimer = 3800;
  var textOutTimer = 3000;
  
  
  function animateText() {
    
    for (var i = 0; i < txtsLen; i++) {
      titles[i].classList.remove("text-in", "text-out");
    }
    titles[index].classList.add("text-in");
  
    setTimeout(function () {
      titles[index].classList.add("text-out");
    }, textOutTimer);
  
    setTimeout(function () {
      if (index == txtsLen - 1) {
        index = 0;
      } else {
        index++;
      }
      animateText();
    }, textInTimer);
  }
  window.requestNextFrame(animateText);
}

function initThemeLiteLogic(){
  
  document.addEventListener('scroll', scrollHandler, {passive: true});

  window.addEventListener("load",function() {
    
    scrollHandler();
    window.requestNextFrame(handleBssFooterStyling);
    
  },{passive: true});
}

if(!window._initThemeLite_run){
  window._initThemeLite_run = 1;
  initThemeLiteLogic();
}



// Might not need this anymore
setTimeout(function() {
  // window.scrollBy(0, 1);
}, 3500)
